import React from "react";
import queryString from "querystring";
import historyHelper from "../../helpers/history-helper";
import { Event } from "../../helpers/event-helper";
import Input from "../form/Input";
import Select from "../form/Select";

import { dptos, dists } from "../../api/data-api";
import Collapse from "../common/Collapse";
import Switch from "../form/Switch";

import Fa from "../common/Fa";

const form = {
  urbano: [
    {
      label: "Zona",
      attr: "zona",
      desc: "La zona correspondiente del inmueble."
    },
    {
      label: "Manzana",
      attr: "manzana",
      desc: "El número de manzana del inmueble."
    },
    { label: "Lote", attr: "lote", desc: "El número de lote del inmueble." }
  ],
  rural: [
    {
      label: "Padrón",
      attr: "padron",
      desc: "El número de padrón de la cuenta rural."
    }
  ]
};

/**
 * Se encarga de construir un panel que contiene los criterios
 * de filtrado para cuentas corrientes y padrones.
 */
export default class Buscador extends React.Component {
  /**
   * Almacena del estado del componente
   */
  state = {
    loading: false,
    expanded: false,
    urbano: false,
    rural: true,
    dpto: "L",
    dist: 1
  };
  /**
   * Referencia al modal
   */
  modal = React.createRef();

  /**
   * Cuando se renderiza el componete se setea la referencia al
   * componente.
   */
  componentDidMount() {
    this.props.onRef(this);

    Event.subscribe(Event.VISOR_BUSQUEDA, data => {
      this.searchReady(true);
    });
    Event.subscribe(Event.MAP_FEATURE_READY, data => {
      this.searchReady(false);
    });
    Event.subscribe(Event.MAP_FEATURE_ERROR, data => {
      this.searchReady(false);
    });

    this.initComponent();
  }

  /**
   * Se encarga de inicializar el componete, recupera los parametros de
   * la URL y verifica los mismos, corresponde a la modalidad embedible.
   */
  initComponent() {
    const { expanded } = this.props;
    //se recupera las variables
    let query = historyHelper.location.search;
    let args = queryString.parse(query.substring(1));
    const baseQuery =
      typeof args.dpto !== "undefined" && args.dist !== "undefined";
    args.rural = baseQuery && typeof args.padron !== "undefined";
    args.urbano = baseQuery && !args.rural;
    if (args.urbano || args.rural) {
      args.loading = true;
      this.setState(args);
      this.props.onSearch(args);
    }

    this.setState({
      expanded: expanded
    });
  }

  searchReady(search) {
    this.setState({ loading: search });
  }

  /**
   * Se encarga de mostrar el dialgo.
   */
  open = data => {
    this.modal.toggle();
    this.setState({
      expanded: true
    });
  };

  /**
   * Se encarga de manejar el close del dialog.
   */
  close = () => {
    this.setState({
      expanded: false
    });
    this.modal.toggle();
  };

  /**
   * Se encarga de manejar el comportamiento de los radio buttons.
   * @param {*} value
   */
  changeSwitch(value) {
    this.setState(prevState => ({
      urbano: !prevState.urbano,
      rural: !prevState.rural
    }));
  }

  /**
   * Se encarga de manejar el change de los componetes del formulario
   * @param {*} name nombre del atributo
   * @param {*} val valor
   */
  onChange(name, val) {
    this.setState({ [name]: val });
  }

  /**
   * Valida que el formulario sea válido
   */
  validate() {
    return (
      this.state.dpto &&
      this.state.dist &&
      ((this.state.urbano &&
        this.state.zona &&
        this.state.lote &&
        this.state.manzana) ||
        (this.state.rural && this.state.padron))
    );
  }

  /**
   * Este método se encarga de disparar la busqueda de las parcelas.
   */
  buscar = () => {
    if (this.validate()) {
      this.setState({ loading: true });
      this.props.onSearch(this.state);
    }
  };

  /**
   * Se encarga de renderizar el fomulario de busqueda que corresponde
   * al partial aplicable a los campos de cuentas corrientes y padrones.
   */
  renderForm() {
    const key = !this.state.urbano ? "rural" : "urbano";
    return (
      <div className="column" id="formulario-busqueda">
        <div className="columns">
          {form[key].map((item, index) => {
            let val = this.state[item.attr]
              ? parseInt(this.state[item.attr])
              : undefined;
            return (
              <div key={index} className="column">
                <Input
                  value={this.state[item.attr]}
                  type="number"
                  label={item.label}
                  placeholder={item.label}
                  help={item.desc}
                  onChange={val => this.onChange(item.attr, val)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  /**
   * Construye el formulario con los filtros de departamento y distritos.
   */
  buildForm() {
    const { urbano, rural } = this.state;
    return (
      <section className="no-padding">
        <p> Buscar parcelas por cuenta corriente o padrón</p>
        <div>
          <div className="column">
            <div className="field" id="selector-tipo-cuenta">
              <Switch
                className="form-check-input"
                placeholder="Cuentas corrientes"
                value={urbano}
                handleChange={this.changeSwitch.bind(this)}
              />
              <Switch
                className="form-check-input"
                placeholder="Cuentas Rurales"
                value={rural}
                handleChange={this.changeSwitch.bind(this)}
              />
              <p className="help">Seleccione el tipo de inmueble.</p>
            </div>
          </div>
          <div className="column">
            <Select
              label="Departamentos"
              placeholder="Departamentos"
              value={this.state.dpto}
              onChange={val => this.onChange("dpto", val)}
              help="Seleccione el departamento donde se encuentra ubicado el inmueble."
            >
              {dptos.map(option => (
                <option key={option.dpto} value={option.dpto}>
                  {option.dpto} - {option.nombre}
                </option>
              ))}
            </Select>
          </div>
          <div className="column">
            <Select
              label="Distritos"
              value={this.state.dist}
              placeholder="Departamentos"
              help="Seleccione el distrito donde se encuentra ubicado el inmueble."
              onChange={val => this.onChange("dist", val)}
            >
              {dists
                .filter(d => {
                  return d.cod_dpto == this.state.dpto;
                })
                .sort((a, b) => {
                  if (a.cod_dist === b.cod_dist) {
                    return 0;
                  }
                  return a.cod_dist > b.cod_dist ? 1 : -1;
                })
                .map(option => {
                  let _id = parseInt(option.cod_dist.substring(1)) + "";
                  return (
                    <option key={option.cod_dist} value={_id}>
                      {option.cod_dist} - {option.nom_dist}
                    </option>
                  );
                })}
            </Select>
          </div>
          {this.renderForm()}
        </div>
        <div className="column">
          <button
            disabled={this.state.loading}
            id="buscar-parcela"
            onClick={evt => this.buscar()}
            className="button is-primary"
          >
            {!this.state.loading && <span><Fa icon="search-location" />Buscar</span>}
            {this.state.loading && <span><Fa icon="compass fa-spin" />Buscando...</span>}
          </button>
        </div>
      </section>
    );
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    return (
      <Collapse
        open={this.state.expanded}
        styleName="column is-5 float-panel"
        onRef={ref => (this.modal = ref)}
      >
        {this.state.expanded && (
          <nav className="panel buscador">
            <div className="panel-heading">
              Filtros
              <p className="close" onClick={evt => this.close()}>
                <Fa icon="times-circle" />
              </p>
            </div>
            <div className="panel-block">{this.buildForm()}</div>
          </nav>
        )}
      </Collapse>
    );
  }
}
